<template>
    <div style="margin-left:50px;">

            <el-form style="display: flex;flex-wrap: wrap;">
                <el-form-item label="姓名:" style="display: flex;width: 33%;">
                    <!-- <el-select placeholder="请选择姓名" v-model="input1" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select> -->
                    <el-input v-model="input1" type="text"  placeholder="请输入姓名"></el-input>
                </el-form-item>

                <el-form-item label="性别:" style="display: flex;width: 33%;">
                    <el-select placeholder="请选择性别" v-model="input2" style="width: 100%" clearable filterable >
                        <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="岗位:" style="display: flex;width: 33%;" >
                    <!-- <el-select placeholder="请选择岗位" v-model="input3" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList3"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select> -->
                    <el-select style="width: 100%" v-model="input3" popper-class="tree-select-popper" ref="treeSelect">
                         <el-option hidden :value="input3"> </el-option>
                         <el-tree :data="dataTrees" :props="defaultPropss" node-key="deptId" ref="belongingTree"   :highlight-current="true" :check-on-click-node="true" @check="handleTreeCheck1">
                         </el-tree>
                    </el-select>
                </el-form-item>

                <el-form-item label="科目:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择科目" v-model="input4" style="width: 100%" clearable multiple filterable>
                        <el-option   v-for="item in optionList4"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="提交人:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择提交人" v-model="input5" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList5"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否内推:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择是否内推" v-model="input6" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList6"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="简历状态:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择简历状态" v-model="input7" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList7"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="所属城市:" style="display: flex;width: 33%;" >
                    <!-- <el-select placeholder="请选择所属城市" v-model="input9" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList8"  :key="item.id"  :value="item.realname" :label="item.realname"></el-option>
                    </el-select> -->
                    <el-select v-model="input9" clearable filterable placeholder="请选择所属城市" style="width: 100%">
                        <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                        :value="item.dictType"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="提交时间:" style="display: flex; ">
                    <el-date-picker v-model="input8" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>



                <div style="display: flex;justify-content: start;color: #df1b1b;width: 50%; line-height: 30px;"> 简历数量：{{ total }}</div>


                <div style="display: flex;justify-content: end;width: 50%;margin-top: 10px;margin-bottom: 30px;">
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus" @click="AddexportBtnss">添加简历</el-button>
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                </div>

            </el-form>


            <el-table   :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
                <el-table-column prop="resumesId" show-overflow-tooltip label="简历编号"></el-table-column>
                <el-table-column prop="name" show-overflow-tooltip label="姓名"></el-table-column>
                <el-table-column prop="sex" show-overflow-tooltip label="性别">
                    <template slot-scope="scope">
                        <span  v-if=" scope.row.sex === 1 ">男</span>
                        <span  v-if=" scope.row.sex === 2 ">女</span>
                    </template>
                </el-table-column>
                <el-table-column prop="regionName" show-overflow-tooltip label="所属城市"></el-table-column>
                <el-table-column prop="telPhone" show-overflow-tooltip label="手机"></el-table-column>
                <el-table-column prop="email" show-overflow-tooltip label="邮箱"></el-table-column>
                <el-table-column prop="age" show-overflow-tooltip label="年龄"></el-table-column>
                <el-table-column prop="noteUrl" show-overflow-tooltip label="简历上传">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-around;">
                            <el-button type="text"  @click="handleClickView('可预览', scope.row)">可查看</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="deptName" show-overflow-tooltip label="岗位"></el-table-column>
                <el-table-column prop="teach" show-overflow-tooltip label="科目"></el-table-column>
                <el-table-column prop="notePush" show-overflow-tooltip label="是否内推">
                    <template slot-scope="scope">
                        <span  v-if=" scope.row.notePush === 1 ">是</span>
                        <span  v-if=" scope.row.notePush === 2 ">否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pushPeople" show-overflow-tooltip label="内推人"></el-table-column>
                <el-table-column prop="createName" show-overflow-tooltip label="提交人"></el-table-column>
                <el-table-column prop="createTime" show-overflow-tooltip label="提交时间"></el-table-column>
                <el-table-column prop="resumeStatus" show-overflow-tooltip label="简历状态">
                    <template slot-scope="scope">
                        <span  v-if=" scope.row.resumeStatus === 0 ">待面试</span>
                        <span  v-if=" scope.row.resumeStatus === 1 ">面试中</span>
                        <span  v-if=" scope.row.resumeStatus === 2 ">未通过</span>
                        <span  v-if=" scope.row.resumeStatus === 3 ">待发offer</span>
                        <span  v-if=" scope.row.resumeStatus === 4 ">待入职</span>
                        <span  v-if=" scope.row.resumeStatus === 5 ">拒绝offer</span>
                        <span  v-if=" scope.row.resumeStatus === 6 ">已入职</span>
                        <span  v-if=" scope.row.resumeStatus === 7 ">取消面试</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="350">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-around;">
                            <el-button type="text" size="small" @click="handleClickView('编辑', scope.row)">编辑</el-button>
                            <el-button type="text" size="small"  @click="handleClickView('详情', scope.row)">详情</el-button>
                            <el-button type="text" size="small"  @click="handleClickView('发起面试', scope.row)">发起面试</el-button>
                            <el-button :disabled="scope.row.resumeStatus !== 3" type="text" size="small"  @click="handleClickView('offer', scope.row)">offer发放</el-button>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column fixed="right" width="200">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-around;">
                            <el-button type="primary" size="small" class="btns"  @click="handleClickView('发起面试', scope.row)">发起面试</el-button>
                            <el-button type="primary" size="small" class="btns"  @click="handleClickView('offer', scope.row)">offer发放</el-button>
                        </div>
                    </template>
                </el-table-column> -->
            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageNum" :page-size="pageSize"
                layout="prev, pager, next,sizes, jumper" :total="total">
            </el-pagination>




        <div class="box"  v-if="ShowAddTemplateDialog">

            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;">
                <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="handleShowAddTemplateDialogClose"><i class="el-icon-close"></i> </div>
                <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">{{ShowAddTemplateDialogTltie}}</div>
            </div>

            <div style="display: flex;">

                <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;height:82vh;padding: 0px 30px; overflow: auto;">
                <div style="margin-bottom: 40px;">

                    <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 10px; font-size: 15px;font-weight: 900;">附件资料</div>
                    <el-progress :percentage="100"></el-progress>

                    <div style="display: flex;margin-top: 30px; justify-content: space-between;">
                        <div style="width: 40%; padding-left: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">简历编号</div>
                            <div style=""><el-input :disabled="true" v-model="resumeNumber1"></el-input></div>
                        </div>
                        <div style="width: 40%;padding-right: 40px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">简历上传</div>
                            <div style="">
                                <!-- <el-input  v-if="resumeNumber2"  v-model="resumeNumber2"></el-input> -->
                                <div v-if="resumeNumber2" style="display: flex;border: 1px solid #DCDFE6; height: 32px; border-radius: 5px;padding-top: 10px;">
                                     <span @click="handleClickPeview" style="padding-left: 10px;">{{resumeNumber2}}</span>
                                     <i :class="isDisabled ? 'no-click' : '' " style="padding-top: 3px;color: #df1b1b;margin-left: 10px;" class="el-icon-circle-close" @click="handleDelet"></i>
                                </div>
                                <el-button v-else style="width: 100%;" type="primary" plain @click="handleShowUpload" :disabled="isDisabled">上传简历</el-button>
                            </div>
                        </div>
                    </div>


                    <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 30px; font-size: 15px;font-weight: 900;">意向信息</div>
                    <el-progress :percentage="100"></el-progress>

                    <div style="display: flex;margin-top: 30px; justify-content: space-between;">
                        <div style="width: 40%;padding-left: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">选择意向岗位</div>
                            <div style="">
                                <!-- <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber3" autocomplete="off" placeholder="请选择职级" clearable>
                                    <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                    :value="jobStatu.jobId"></el-option>
                                </el-select> -->
                                <el-select :disabled="isDisabled" style="width: 100%" v-model="resumeNumber3" popper-class="tree-select-popper" ref="treeSelect1">
                                    <el-option hidden :value="resumeNumber3"> </el-option>
                                    <el-tree
                                        :data="dataTrees"
                                        :props="defaultPropss"
                                        node-key="deptId"
                                        ref="belongingTree"
                                        :highlight-current="true"
                                        :check-on-click-node="true"
                                        @check="handleTreeCheck">
                                    </el-tree>
                                </el-select>
                            </div>
                        </div>
                        <div style="width: 40%; padding-right: 40px;">
                          <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">所属城市</div>
                            <div style="">
                                <el-select :disabled="isDisabled" style="width: 100%" v-model="resumeNumber13" popper-class="tree-select-popper" ref="treeSelect1">
                                    <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                                    :value="item.dictType"></el-option>
                                </el-select>
                                <!-- <el-select v-model="resumeNumber13" clearable filterable placeholder="请选择所属城市" style="width: 100%">
                                    <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                                    :value="item.dictType"></el-option>
                                </el-select> -->
                            </div>
                        </div>
                    </div>


                    <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 30px; font-size: 15px;font-weight: 900;">个人资料</div>
                    <el-progress :percentage="100"></el-progress>

                    <div style="display: flex;margin-top: 30px; justify-content: space-between;flex-wrap: wrap; justify-content: space-between;">
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">姓名<span style="color:red;font-size: 12px;">（必填）</span></div>
                            <div style="">
                                <el-input :disabled="isDisabled" v-model="resumeNumber4" type="text" show-word-limit maxlength="4" placeholder="请输入姓名"></el-input>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">年龄<span style="color:red;font-size: 12px;">（必填）</span></div>
                            <div style="">
                                <el-input :disabled="isDisabled" v-model="resumeNumber5" type="text" show-word-limit maxlength="2" placeholder="请输入年龄"></el-input>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">性别<span style="color:red;font-size: 12px;">（必填）</span></div>
                            <div style="">
                                <el-select :disabled="isDisabled" placeholder="请选择性别" v-model="resumeNumber6" style="width: 100%" clearable filterable ref="selectRef"  @change="handleSelectChange">
                                    <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">手机<span style="color:red;font-size: 12px;">（必填）</span></div>
                            <div style="">
                                <el-input :disabled="isDisabled" v-model="resumeNumber7" type="text" show-word-limit maxlength="11" placeholder="请输入手机"></el-input>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">邮箱<span style="color:red;font-size: 12px;">（必填）</span></div>
                            <div style="">
                                <el-input :disabled="isDisabled" v-model="resumeNumber8" type="text" show-word-limit maxlength="25" placeholder="请输入邮箱"></el-input>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">科目</div>
                            <div style="">
                                <el-select :disabled="isDisabled" multiple  placeholder="请选择科目"   v-model="resumeNumber9"   style="width: 100%"  clearable  filterable>
                                    <el-option  v-for="item in subjectArr" :key="item.id" :value="item.id"  :label="item.categoryName"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">毕业时间<span style="color:red;font-size: 12px;">（必填）</span></div>
                            <div style="">
                                <el-date-picker  :disabled="isDisabled" style="width: 100%;" v-model="resumeNumber10" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">毕业学校<span style="color:red;font-size: 12px;">（必填）</span></div>
                            <div style="">
                                <el-input :disabled="isDisabled" v-model="resumeNumber11" type="text" show-word-limit maxlength="30" placeholder="请输入毕业学校"></el-input>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">学历<span style="color:red;font-size: 12px;">（必填）</span></div>
                            <div style="">
                                <el-input :disabled="isDisabled" v-model="resumeNumber15" type="text" show-word-limit maxlength="20" placeholder="请输入学历"></el-input>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">

                        </div>
                    </div>


                    <div style="color:rgb(37 34 34);text-align: start;padding-left: 10px;  margin-top: 30px; font-size: 15px;font-weight: 900;">是否内推</div>
                    <div style="text-align: start;padding-left: 10px;margin-top: 15px;">
                        <el-radio :disabled="isDisabled" v-model="resumeNumber12" label="是" @click.native="handleRadio('是')">是</el-radio>
                        <el-radio :disabled="isDisabled" v-model="resumeNumber12" label="否" @click.native="handleRadio('否')">否</el-radio>
                    </div>


                    <div style="color:rgb(37 34 34);text-align: start;padding-left: 10px;  margin-top: 30px; font-size: 15px;font-weight: 900;"></div>
                    <div style="text-align: start;padding-left: 10px;margin-top: 15px; width: 150px;" v-if="InternalReferrer">
                        <el-input  :disabled="true" v-model="InternalReferrer" type="text" show-word-limit maxlength="4"></el-input>
                    </div>



                 </div>
                </div>

                <div class="" style="width: 40%;background-color: #FFF;border-radius: 10px; padding-top: 15px; padding-right: 30px;margin-right: 7px;height: 80.1vh;overflow: auto;" v-if="isShowEdit">
                    <h4>流程动态</h4>
                    <el-timeline>
                        <div v-for="(itme, index) in timelineList" :key="index">
                            <el-timeline-item :timestamp="itme.operation" placement="top">
                                <el-card style="text-align: start;">
                                    <p v-if="itme.initiator">发起人：{{ itme.initiator }}</p>
                                    <p v-if="itme.resumesCreateTime">发起时间：{{ itme.resumesCreateTime }}</p>
                                    <p v-if="itme.operation">操作：{{ itme.operation }}</p>
                                    <p v-if="itme.operation">面试节点：{{ itme.operation }}</p>
                                    <p v-if="itme.interviewName">面试人：{{ itme.interviewName }}</p>
                                    <p v-if="itme.interviewerName">面试官：{{ itme.interviewerName }}</p>
                                    <p v-if="itme.categoryNames">面试科目：{{ itme.categoryNames }}</p>
                                    <p v-if="itme.interviewDate">面试时间：{{ itme.interviewDate }}</p>
                                    <p v-if="itme.interviewStartTime">面试开始时间：{{ itme.interviewStartTime }}</p>
                                    <p v-if="itme.interviewEndTime">面试结束时间：{{ itme.interviewEndTime }}</p>
                                    <p v-if="itme.interviewOpinion">面试意见：{{ itme.interviewOpinion }}</p>
                                    <p v-if="itme.interviewResult">面试结果：{{ itme.interviewResult }}</p>
                                    <p v-if="itme.offerSendStatus">发送状态：{{ itme.offerSendStatus }}</p>
                                    <p v-if="itme.offerSendDate">发送时间：{{ itme.offerSendDate }}</p>
                                    <p v-if="itme.offerFollowStatus">offer状态：{{ itme.offerFollowStatus }}</p>
                                    <p v-if="itme.entryTime">待入职日期：{{ itme.entryTime }}</p>
                                    <p v-if="itme.interviewDatas" @click="handleClick(itme.interviewDatas)"> 相关资料：<span style="color:#41cae1;" >{{ itme.interviewDatas[0].name }}</span></p>
                                    <div style="display: flex;justify-content: end;" v-if="index >= 1">
                                        <el-button  size="small" class="btns" style="height: 30px;" @click="handleCot(itme)">面试意见</el-button>
                                        <el-button :disabled="itme.interviewResult === '未通过' || itme.interviewResult === '未面试'"  size="small" class="btns" style="height: 30px;" @click="handleClr(itme.interviewId)">取消面试</el-button>
                                    </div>
                                </el-card>
                                <!-- <span style="position: absolute; height: 16px; background: #ed9612; top: 0px; left: -3px; width: 16px; border-radius: 50%;"></span> -->
                                <span :style="{ height: itme.operation === 'offer跟进' ? '92%' : '101%' }" style="position: absolute; height: 101%; background: rgb(232 233 233); top: 0px; left: 3px; width: 5px;margin-top: 17px;"></span>
                            </el-timeline-item>
                        </div>
                    </el-timeline>
                 </div>

            </div>



            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding: 10px 0px;display: flex;justify-content: end; padding-right: 25px;">
                <span slot="footer" class="dialog-footer">
                    <el-button size="small"  @click="handleShowAddTemplateDialogClose">取 消</el-button>
                    <el-button size="small" v-if="!isDisabled"  type="primary" @click="handleShowAddTemplateDialogSub">确 定</el-button>
                </span>
            </div>

        </div>



        <el-dialog  title="内推人" :visible.sync="handleRadioShow"  width="30%" :before-close="handlehandleRadioShowClose" :close-on-click-modal="false">
            <div style="display: flex;">
                <div style="width: 90px;padding-top: 8px;">内推人：</div>
                <div style=" width: 80%;">
                    <el-input v-model="InternalReferrer" type="text" show-word-limit maxlength="4"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small"  @click="handlehandleRadioShowClose">取 消</el-button>
                <el-button size="small"  type="primary" @click="handlehandleRadioShowSub">确 定</el-button>
            </span>
        </el-dialog>




        <el-dialog title="上传简历" width="50%" style="padding: 50px 50px;" :visible.sync="uploadShowDlong" :before-close="uploadShowDlongCler" :close-on-click-modal="false">
            <el-upload class="upload-demo" style="height: 350px;"
                drag
                action="#"
                :on-remove="handleRemove"
                :beforeUpload="beforeUpload"
                :http-request="handleUpload"
                :on-error="handleError"
                :auto-upload="true"
                :limit="1"
                show-file-list
                :file-list="fileDataList">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="uploadShowDlongCler">取消</el-button>
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="uploadShowDlongSub">保存</el-button>
            </div>
        </el-dialog>




        <div class="box"  v-if="ShowInitiateAnIterviewDialog">
            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding-bottom: 6px;">
                <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="handleShowInitiateAnIterviewDialogClose"><i class="el-icon-close"></i> </div>
            </div>
            <div style="display: flex;margin-left: 11px;width: 98.5%; border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;height: 90vh;">

                <div style="width: 25%;">

                    <div style="width: 100%;height: 55vh;">
                        <div style="width: 90%;  margin-top: 12px;margin-left: 10px; margin-bottom: 10px;">
                            <el-input  placeholder="搜索部门" v-model="departmentInput" @input="handleInput" clearable> <i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                        </div>
                        <div style="width: 100%; height: 1px; border-bottom: 1px solid #ebeef5;  margin-top: 6px;"></div>
                        <div style="height:83.3%;overflow-y: auto;">
                            <div v-if="dataTree.length > 0">
                                <el-tree :data="dataTree" node-key="id" default-expand-all :props="defaultProps"  @node-click="handleClickTree"></el-tree>
                                <div class="v-step-0"></div>
                            </div>
                            <div v-else>
                                <el-empty description="暂无"></el-empty>
                            </div>
                        </div>
                    </div>

                    <div v-if="isTeacherList && isTeacherList.length > 0" style="width: 100%;height: 150px;">
                        <el-divider></el-divider>
                        <el-table  :data="isTeacherList"  @row-click="handleClickTreeRealname"	 :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" border height="250">
                             <el-table-column prop="realname" label="面试官列表">
                                <template slot-scope="scope">
                                    <span style="color:royalblue;"  @click="handleClickTreeRealname(scope.row)">{{scope.row.realname}}</span>
                                </template>
                             </el-table-column>
                        </el-table>
                    </div>
                    <div class="v-step-1"></div>
                </div>


                <div style="width: 50%;border-left: 1px solid #cfcfcf;border-right: 1px solid #cfcfcf;">
                    <h2>时间行程统计表</h2>
                    <div>
                        <div class="demo-app">
                            <div class="demo-app-main">
                                <div class="v-step-2"></div>
                                <FullCalendar  ref="fullCalendar"  class="demo-app-calendar"  :options="calendarOptions">
                                    <template v-slot:eventContent="arg">
                                        <!-- <b>{{ arg.timeText }}</b> -->
                                        <span>{{ arg.event.extendedProps.courseTimeOn }} ~ {{ arg.event.extendedProps.courseEndTime }}</span>
                                        <span>{{ arg.event.title }}</span>
                                    </template>
                                </FullCalendar>
                            </div>
                        </div>
                    </div>
                </div>


                <div style="width: 25%;">
                    <h2>面试安排</h2>
                    <div class="v-step-3"></div>
                    <div style=" margin-top: 20px;overflow: auto; height: 80vh;">
                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">一面面试:</div>
                            <div style="width: 70%;">
                                <el-select :disabled="isDisabled1 !== 0" placeholder="请选择面试官"  v-model="InterviewInput1"   style="width: 100%"  clearable  filterable>
                                    <el-option  v-for="item in isTeacherList" :key="item.id" :value="item.id"  :label="item.realname"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试类型:</div>
                            <div style=" width: 70%;">
                                <el-select :disabled="isDisabled1 !== 0" placeholder="请选择面试类型"  v-model="InterviewType1"   style="width: 100%"  clearable  filterable>
                                    <el-option  v-for="item in isTypeList" :key="item.id" :value="item.id"  :label="item.realname"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试日期:</div>
                            <div style=" width: 70%;">
                                <el-date-picker :disabled="isDisabled1 !== 0" style="width: 100%;" v-model="InterviewTime1" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 80px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试时间:</div>
                            <div style=" width: 70%; display: flex;height: 42px;overflow: hidden;" :class="isDisabled1 !== 0 ? 'no-click' : ''">
                                <!-- <el-time-picker style="width: 100%;" is-range   v-model="InterviewTime11" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker> -->

                                <!-- <el-time-select :disabled="isDisabled1 === 2"  v-model="InterviewStartTime11" :picker-options="{ start: '01:01', step: '00:01', end: '24:00' }"></el-time-select>
                                <el-time-select :disabled="isDisabled1 === 2"  v-model="InterviewEndTime11" :picker-options="{ start: '01:01', step: '00:01', end: '24:00' }"></el-time-select> -->

                                <mz-time-select
                                    :disabled="isDisabled1 !== 0"
                                    :timePeriod="'start'"
                                    :childPlaceholder="'开始时间'"
                                    @startTimeSelect="startTimeSelect"
                                    v-model="InterviewStartTime11"
                                    :valueTime="InterviewStartTime11">
                                </mz-time-select>

                                <mz-time-select
                                    :disabled="isDisabled1 !== 0"
                                    :timePeriod="'end'"
                                    :childPlaceholder="'结束时间'"
                                    @startTimeSelect="startTimeSelect"
                                    v-model="InterviewEndTime11"
                                    :valueTime="InterviewEndTime11">
                                </mz-time-select>

                            </div>
                        </div>






                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">二面面试:</div>
                            <div style=" width: 70%;">
                                <el-select  :disabled="isDisabled2 !== 0" placeholder="请选择面试官"  v-model="InterviewInput2"   style="width: 100%"  clearable  filterable>
                                    <el-option  v-for="item in isTeacherList" :key="item.id" :value="item.id"  :label="item.realname"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试类型:</div>
                            <div style=" width: 70%;">
                                <el-select :disabled="isDisabled2 !== 0" placeholder="请选择面试类型"  v-model="InterviewType2"   style="width: 100%"  clearable  filterable>
                                    <el-option  v-for="item in isTypeList" :key="item.id" :value="item.id"  :label="item.realname"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试日期:</div>
                            <div style=" width: 70%;">
                                <el-date-picker :disabled="isDisabled2 !== 0" style="width: 100%;" v-model="InterviewTime2" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 80px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试时间:</div>
                            <div style=" width: 70%; display: flex;height: 42px;overflow: hidden;" :class="isDisabled2 !== 0 ? 'no-click' : ''">
                                <!-- <el-time-picker style="width: 100%;" is-range   v-model="InterviewTime22" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker> -->
                                <!-- <el-time-select :disabled="isDisabled2 === 2"  v-model="InterviewStartTime22" :picker-options="{ start: '01:01', step: '00:01', end: '24:00' }"></el-time-select>
                                <el-time-select :disabled="isDisabled2 === 2"  v-model="InterviewEndTime22" :picker-options="{ start: '01:01', step: '00:01', end: '24:00' }"></el-time-select> -->

                                <mz-time-select
                                    :disabled="isDisabled2 !== 0"
                                    :timePeriod="'start'"
                                    :childPlaceholder="'开始时间'"
                                    @startTimeSelect="startTimeSelect2"
                                    v-model="InterviewStartTime22"
                                    :valueTime="InterviewStartTime22">
                                </mz-time-select>

                                <mz-time-select
                                    :disabled="isDisabled2 !== 0"
                                    :timePeriod="'end'"
                                    :childPlaceholder="'结束时间'"
                                    @startTimeSelect="startTimeSelect2"
                                    v-model="InterviewEndTime22"
                                    :valueTime="InterviewEndTime22">
                                </mz-time-select>



                            </div>
                        </div>




                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">三面面试:</div>
                            <div style=" width: 70%;">
                                <el-select :disabled="isDisabled3 !== 0"  placeholder="请选择面试官"  v-model="InterviewInput3"   style="width: 100%"  clearable  filterable>
                                    <el-option  v-for="item in isTeacherList" :key="item.id" :value="item.id"  :label="item.realname"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试类型:</div>
                            <div style=" width: 70%;">
                                <el-select  :disabled="isDisabled3 !== 0" placeholder="请选择面试类型"  v-model="InterviewType3"   style="width: 100%"  clearable  filterable>
                                    <el-option  v-for="item in isTypeList" :key="item.id" :value="item.id"  :label="item.realname"> </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 20px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试日期:</div>
                            <div style=" width: 70%;">
                                <el-date-picker :disabled="isDisabled3 !== 0" style="width: 100%;" v-model="InterviewTime3" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                            </div>
                        </div>
                        <div style="display: flex; margin-bottom: 80px;">
                            <div style="padding-top: 10px;margin-right: 10px;margin-left: 14px;">面试时间:</div>
                            <div style=" width: 70%; display: flex;height: 42px;overflow: hidden;" :class="isDisabled3 !== 0 ? 'no-click' : ''">
                                <!-- <el-time-picker style="width: 100%;" is-range   v-model="InterviewTime33" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker> -->
                                <!-- <el-time-select :disabled="isDisabled3 === 2"  v-model="InterviewStartTime33" :picker-options="{ start: '01:01', step: '00:01', end: '24:00' }"></el-time-select>
                                <el-time-select :disabled="isDisabled3 === 2"  v-model="InterviewEndTime33" :picker-options="{ start: '01:01', step: '00:01', end: '24:00' }"></el-time-select> -->


                                <mz-time-select
                                    :disabled="isDisabled3 !== 0"
                                    :timePeriod="'start'"
                                    :childPlaceholder="'开始时间'"
                                    @startTimeSelect="startTimeSelect3"
                                    v-model="InterviewStartTime33"
                                    :valueTime="InterviewStartTime33">
                                </mz-time-select>

                                <mz-time-select
                                    :disabled="isDisabled3 !== 0"
                                    :timePeriod="'end'"
                                    :childPlaceholder="'结束时间'"
                                    @startTimeSelect="startTimeSelect3"
                                    v-model="InterviewEndTime33"
                                    :valueTime="InterviewEndTime33">
                                </mz-time-select>


                            </div>
                        </div>

                    </div>

                    <div style="position: fixed;bottom: 55px;right: 20px; ">
                        <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="handleShowInitiateAnIterviewDialogClose">取消</el-button>
                        <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="handleArrangeSub">保存</el-button>
                    </div>
                </div>

            </div>
        </div>



        <el-dialog title="面试信息" width="50%" style="padding: 50px 50px;" :visible.sync="showInterViewInfo" :before-close="showInterViewInfoCler" :close-on-click-modal="false">
            <div style="display: flex; flex-wrap: wrap;">

                <div style="display: flex; margin-bottom: 20px;width: 50%;">
                    <div style="margin-left: 14px;width: 30%;text-align: end;">面试岗位:</div>
                    <div style=" width: 70%;text-align: start;padding-left: 21px;line-height: 18px;">{{clickInfoObj.deptName}}</div>
                </div>

                <div style="display: flex; margin-bottom: 20px;width: 50%;">
                    <div style="margin-left: 14px;width: 33%;text-align: end;">面试官:</div>
                    <div style=" width: 70%;text-align: start;padding-left: 21px;line-height: 18px;">{{clickInfoObj.interviewName}}</div>
                </div>

                <div style="display: flex; margin-bottom: 20px;width: 50%;">
                    <div style="margin-left: 14px;width: 30%;text-align: end;">面试科目:</div>
                    <div style=" width: 70%;text-align: start;padding-left: 21px;line-height: 18px;">{{clickInfoObj.courseName}}</div>
                </div>

                <div style="display: flex; margin-bottom: 20px;width: 50%;">
                    <div style="margin-left: 14px;width: 30%;text-align: end;">面试日期:</div>
                    <div style=" width: 70%;text-align: start;padding-left: 21px;line-height: 18px;">{{clickInfoObj.courseDate}}</div>
                </div>

                <div style="display: flex; margin-bottom: 20px;width: 50%;">
                    <div style="margin-left: 14px;width: 33%;text-align: end;">面试人:</div>
                    <div style=" width: 70%;text-align: start;padding-left: 21px;line-height: 18px;">{{clickInfoObj.teacherName}}</div>
                </div>

                <div style="display: flex; margin-bottom: 20px;width: 50%;">
                    <div style="margin-left: 14px;width: 30%;text-align: end;">面试时间:</div>
                    <div style=" width: 70%;text-align: start;padding-left: 21px;line-height: 18px;">{{clickInfoObj.courseTimeOn}}~{{clickInfoObj.courseEndTime}}</div>
                </div>

                <div style="display: flex; margin-bottom: 20px;width: 50%;">
                    <div style="margin-left: 14px;width: 30%;text-align: end;">性别:</div>
                    <div style=" width: 70%;text-align: start;padding-left: 21px;line-height: 18px;">{{clickInfoObj.sex}}</div>
                </div>
                <div style="display: flex; margin-bottom: 20px;width: 50%;"> </div>

                <div style="display: flex; margin-bottom: 20px;width: 50%;">
                    <div style="margin-left: 14px;width: 200px;text-align: end;">简历附件:</div>
                    <div style=" width: 70%;color:#00b6ff;text-align: start;padding-left: 21px;" v-for="(itme,index) in clickInfoObj.noteUrl" :key="index">
                        <span @click="handleClickImg(itme)" v-if="itme.name">{{itme.name}}</span>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="showInterViewInfoCler">取消</el-button>
            </div>
       </el-dialog>




        <div class="box"  v-if="ShowCurrentComponentDialog">
            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding-bottom: 6px;">
                <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="handleShowCurrentComponentDialogClose"><i class="el-icon-close"></i> </div>
                <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">{{ currentComponent === 'followUpComponents' ? 'offer基本信息' : currentComponent === 'grantComponents' ? 'offer发放' : '入职填报' }}</div>
            </div>
            <div>
                <component :is="currentComponent" @handleEventChildren="handleEventChildren" :resumesId="resumesId"></component>
            </div>
        </div>




        <v-tour name="myTour" :steps="steps" :options="myOptions" ></v-tour>


        <el-dialog title="预览简历" width="50%" style="padding: 0px 50px;" :visible.sync="showInfo" :before-close="showshowInfoViewInfoCler" :close-on-click-modal="false">
           <Guciya v-if="showInfo" :url="urls"></Guciya>
        </el-dialog>

        <el-dialog title="预览简历" width="60%" style="padding: 0px 50px;" :visible.sync="showInfos" :before-close="showshowInfoViewInfoClers" :close-on-click-modal="false">
            <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload" class="mr10"> 下 载</el-button>
            <GuciYa-VueOfficeDocx :src="docxContent" ref="docxEditor" :options="editorOptions"></GuciYa-VueOfficeDocx>
        </el-dialog>

        <el-dialog title="预览MP3" width="60%" style="padding: 0px 50px;" :visible.sync="showInfosMp3" :before-close="showshowInfoViewInfoClers3" :close-on-click-modal="false">
            <audio controls>
                <source :src="showInfosMp3" type="audio/ogg">
                <source :src="showInfosMp3" type="audio/mpeg">
                您的浏览器不支持音频。
            </audio>
        </el-dialog>

        <el-dialog title="预览MP4" width="60%" style="padding: 0px 50px;" :visible.sync="showInfosMp4" :before-close="showshowInfoViewInfoClers4" :close-on-click-modal="false">
            <video width="640" height="360" controls>
                <source :src="showInfosMp4" type="video/mp4">
                <source :src="showInfosMp4" type="video/ogg">
                您的浏览器不支持视频。
            </video>
        </el-dialog>

        <el-dialog title="预览图片" width="60%" style="padding: 0px 50px;" :visible.sync="showInfoss" :before-close="showshowInfoViewInfoClers5" :close-on-click-modal="false">
            <img :src="urls" :alt="urls" style="width: 80%;">
        </el-dialog>


        <el-dialog title="预览简历" width="60%" style="padding: 0px 50px;" :visible.sync="showImgDing" :before-close="showImgDingClers5" :close-on-click-modal="false">
            <div style="margin-bottom: 20px;">
                <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload1" class="mr10"> 下 载</el-button>
            </div>
            <div>
                <img :src="showImgDingurlsss" :alt="showImgDingurlsss" style="width: 100%;">
            </div>
        </el-dialog>


        <el-dialog title="取消面试" width="60%" style="padding: 0px 50px;" :visible.sync="handleClrShow" :before-close="handleClrShowClers5" :close-on-click-modal="false">
            <div style="display: flex;">
                <div style="width: 100px;padding-top: 10px;">取消原因：</div>
                <el-input type="textarea" placeholder="请输入取消原因" v-model="handleClrShowtextarea"  :autosize="{ minRows: 6, maxRows: 6 }"  maxlength="300" show-word-limit></el-input>
            </div>

            <span slot="footer" class="dialog-footer">
                <div style="text-align: end;">
                    <el-button size="small" type="primary" @click="closeEditDialogSubt">确认</el-button>
                    <el-button size="small"  @click="handleClrShowClers5">关闭</el-button>
                </div>
            </span>
        </el-dialog>


        <el-dialog title="面试意见评价" width="60%" style="padding: 0px 50px;" :visible.sync="handleCotShow" :before-close="handleCotShowClers5" :close-on-click-modal="false">
            <div style="display: flex;margin-bottom: 30px;">
                <div style="width: 100px;">面试意见：</div>
                <div>
                    <el-radio v-model="CotRadio" :label="2">通过</el-radio>
                    <el-radio v-model="CotRadio" :label="1">未通过</el-radio>
                </div>
            </div>
            <div style="display: flex;margin-bottom: 30px;">
                <div style="width: 100px;padding-top: 10px;margin-left: 8px;">面试评价：</div>
                <el-input type="textarea" placeholder="请输入面试评价" v-model="CotRadioCntShowtextarea"  :autosize="{ minRows: 6, maxRows: 6 }"  maxlength="300" show-word-limit></el-input>
            </div>
            <div style="display: flex;margin-bottom: 30px;">
                <div style="width: 100px;padding-top: 10px;">上传图片：</div>
                <div>
                    <div style="padding-top: 12px; color: #40a9ff;" v-if="resumeNumber2S">
                        <span @click="handleClickImg({url:resumeNumber2UrlS})">{{ resumeNumber2S }}</span>
                        <span style="margin-left: 100px;" @click="handleClickClr">×</span>
                    </div>
                    <el-button v-else style="width: 100%;" type="primary" plain @click="handleShowUpload" >上传</el-button>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <div style="text-align: end;">
                    <el-button size="small" type="primary" @click="handleCotShowDialogSubt">确认</el-button>
                    <el-button size="small"  @click="handleCotShowClers5">关闭</el-button>
                </div>
            </span>
        </el-dialog>


    </div>
</template>


<script>

import mammoth from "mammoth";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { generateRandomCode, isDate} from "../utils/date";
import { getSubject } from "@/api/fiveClassApi"
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import zhcn from "@fullcalendar/core/locales/zh-cn";

import followUpComponents from "./components/followUpComponents";
import grantComponents from "./components/grantComponents";
import employmentComponents from "./components/employmentComponents";
import Guciya from "./components/Guciya-compoents";
export default {
    components: { FullCalendar, followUpComponents, grantComponents, employmentComponents, Guciya },
    data(){
        return{

            resumeNumber15:'',


            CotRadio:0,
            CotRadioCntShowtextarea:'',

            optionList8:[{id:1,realname:'北京'},{id:2,realname:'深圳'}],
            input9: '',
            optionsListt:[
                {dictValue:"北京", dictType:1 },
                {dictValue:"深圳", dictType:2 },
            ],

            editorOptions: {
                toolbar: true,
                width: '800px',
                height: '600px'
            },
            showInfos:false,
            docxContent: '',


            showInfo: false,
            urls:'',

            myOptions: {
                highlight: true,
                labels: {  buttonSkip: '跳过引导教程',   buttonPrevious: '上一步',   buttonNext: '下一步',  buttonStop: '结束' }
      		},

            steps: [
                {
                    target: '.v-step-0',
                    header: { title: '操作步骤'},
                    content: `点击 <strong>对应部门</strong>!`,
                    params: { placement: 'left' }
                },
                {
                    target: '.v-step-1',
                    header: { title: '操作步骤'},
                    content: `点击 <strong>对应老师名字</strong>!`,
                    params: { placement: 'left' }
                }
                ,
                {
                    target: '.v-step-2',
                    header: { title: '操作步骤'},
                    content: `<strong>查看行程</strong>!`,
                    params: { placement: 'left' }
                },
                {
                    target: '.v-step-3',
                    header: { title: '操作步骤'},
                    content: `<strong>安排面试</strong>!`,
                    params: { placement: 'left' }
                }
            ],


            ShowCurrentComponentDialog: false,
            currentComponent:'',

            defaultProps:{children: 'children', label: 'deptName' },
            dataTree:[],

            input1: '',
            input2: '',
            input3: '',
            input4: '',
            input5: '',
            input6: '',
            input7: '',
            input8:[],
            optionList1: [],
            optionList2: [{id:1,realname:'男'},{id:2,realname:'女'}],
            optionList3: [],
            optionList4: [],
            optionList5: [],
            optionList6: [{id:1,realname:'是'},{id:2,realname:'否'}],
            optionList7: [{id:0,realname:'待面试'},{id:1,realname:'面试中'},{id:2,realname:'未通过'},{id:3,realname:'待发offer'},{id:4,realname:'待入职'},{id:5,realname:'拒绝offer'},{id:6,realname:'已入职'},{id:7,realname:'取消面试'}],

            pageNum: 1,
            pageSize: 10,
            total: 0,

            dataList: [],


            ShowAddTemplateDialog: false,
            ShowAddTemplateDialogTltie: '添加简历',


            resumeNumber1: '',
            resumeNumber2: '',
            resumeNumber3: '',
            resumeNumber4: '',
            resumeNumber5: '',
            resumeNumber6: '',
            resumeNumber7: '',
            resumeNumber8: '',
            resumeNumber9: '',
            resumeNumber10: '',
            resumeNumber11: '',
            resumeNumber12: '',

            resumeNumber13: 1,

            jobs:[],
            subjectArr:[],


            handleRadioShow: false,
            InternalReferrer:'',

            uploadShowDlong:false,
            fileDataList:[],


            resumeNumber2Url:'',


            isShowEdit: false,
            timelineList:[],

            isDisabled:false,


            ShowInitiateAnIterviewDialog: false,

            departmentInput:'',
            dataTrees:[],
            defaultPropss:{ children: 'children', label: 'deptName' },


            calendarOptions: {
                handleWindowResize: true,
                eventColor: this.getEventColor, // 使用方法来确定颜色
                firstDay: 1,
                allDaySlot: false, // 不显示all-day
                firstHour: 6,
                slotMinTime: "06:00:00",
                slotMaxTime: "24:00:00",
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin, // needed for dateClick
                ],
                datesSet: this.handleDatesSet,
                headerToolbar: {
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay",
                },

                /* 设置按钮文字 */
                buttonText: {
                    today: "今天",
                    dayGridMonth: "月",
                    timeGridWeek: "周",
                    timeGridDay: "日",
                },
                locale: "zh-cn",
                // dayGridMonth, timeGridWeek,timeGridDay
                initialView: "dayGridMonth",
                // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                // handleViewRender,
                eventDidMount: function (info) {
                    if (info.event.extendedProps.isShowbgcColor) {  info.el.style.background = "darkgray" }
                    else {  info.el.style.background = "#3788d8" }
                    if ( info.event.extendedProps.classEnding == 1 &&  info.event.extendedProps.isFirst !== 1 ) {
                          info.el.style.background = "orange"
                          info.el.style.borderColor = "orange"
                    }
                    if ( info.event.extendedProps.isFirst == 1 &&info.event.extendedProps.classEnding == 1) {
                          info.el.style.background = "#E380E3";
                          info.el.style.borderColor = "#E380E3";
                    }
                    if (info.event.extendedProps.isFirst == 1 &&info.event.extendedProps.classEnding !== 1) {
                          info.el.style.background = "#54bcbd";
                          info.el.style.borderColor = "#54bcbd";
                    }
                },
                events: [],
                customButtons: {
                next: {
                    click: this.nextClick,
                },
                prev: {
                    click: this.prevClick,
                },
                },
                eventColor: function (event) {
                if (event.start.isBefore(new Date())) {
                    return "f0f0f0"; // 过去事件的背景颜色
                } else {
                    return "#008000"; // 未来事件的背景颜色
                }
                },

                // select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                /* you can update a remote database when these fire:
                eventAdd:
                eventChange:
                eventRemove:
                */
            },


            InterviewInput1: '',
            InterviewInput2: '',
            InterviewInput3: '',
            InterviewTime1: '',
            InterviewTime2: '',
            InterviewTime3: '',

            InterviewTime11: [new Date(2016, 9, 10, 10, 0), new Date(2016, 9, 10, 19, 0)],
            InterviewTime22: [new Date(2016, 9, 10, 10, 0), new Date(2016, 9, 10, 19, 0)],
            InterviewTime33: [new Date(2016, 9, 10, 10, 0), new Date(2016, 9, 10, 19, 0)],

            InterviewStartTime11:'',
            InterviewEndTime11:'',
            InterviewStartTime22:'',
            InterviewEndTime22:'',
            InterviewStartTime33:'',
            InterviewEndTime33:'',

            interviewId1:'',
            interviewId2:'',
            interviewId3:'',

            showInterViewInfo: false,
            resumeNumber3Id:'',

            input3Id:'',

            resumesId:'',

            types:'添加',

            startTime:'',
            endTime:'',

            isTeacherList:[],
            teacherId:'',

            InterviewType1: '',
            InterviewType2: '',
            InterviewType3: '',
            isTypeList:[{id:1,realname:'线上'},{id:2,realname:'线下'}],

            isDisabled1: 0,
            isDisabled2: 0,
            isDisabled3: 0,

            clickInfoObj: {},

            docxContentMp4:'',
            docxContentMp3:'',
            showInfosMp4: false,
            showInfosMp3: false,

            showInfoss:false,

            showImgDing: false,
            showImgDingurlsss:'',


            handleCotShow: false,
            handleClrShow: false,
            handleClrShowtextarea:'',
            interviewId:'',

            resumeNumber2S:'',
            resumeNumber2UrlS:'',


        }
    },

    mounted(){
        this.handleGetApiAll()
        this.handleInitTime()

        axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
        { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
        }).then((res)=>{ this.optionsListt = res.data.data})


    },


    methods:{
        closeEditDialogSubt(){
            if(this.handleClrShowtextarea){
                let data = {
                    interviewId: this.interviewId,
                    cancelCause: this.handleClrShowtextarea
                }
                axios.post(`${apiBaseUrl}/interview/cancelInterview`, data, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                    if(res.data.code === 200){
                        this.$message({type: 'success', message: res.message})
                        this.handleClrShowtextarea = ''
                        this.handleGetApigetInterviewFlowInfo(this.resumeNumber1)
                        this.handleClrShow = false
                    }else{
                        this.$message({type: 'error', message: res.data.message})
                    }
                })
            }else{
                this.$message({type: 'warning', message: '请添加取消原因~' })
            }
        },
        handleCotShowDialogSubt(){
            if(this.CotRadio === 1 || this.CotRadio === 2){
                let flie = [{  name: this.resumeNumber2S,  url: this.resumeNumber2UrlS  }]
                let data = {
                    interviewId: this.interviewId,
                    interviewResult: this.CotRadio,
                    interviewOpinion: this.CotRadioCntShowtextarea,
                    interviewData: JSON.stringify(flie),
                }
                axios.post(`${apiBaseUrl}/interview/updateInterview/${this.interviewId}`, data, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                    if(res.data.code === 200){
                        this.$message({type: 'success', message: res.data.message })
                        this.CotRadioCntShowtextarea = ''
                        this.resumeNumber2S = ''
                        this.resumeNumber2UrlS = ''
                        this.CotRadio = 0
                        this.handleGetApigetInterviewFlowInfo(this.resumeNumber1)
                        this.handleCotShow = false
                    }else{
                        this.$message({type: 'error', message: res.data.message })
                    }
                }).catch((err)=>{
                    this.$message({type: 'error', message: err })
                })
            }else{
                this.$message({type: 'warning', message: '请选择面试意见~' })
            }

        },

        handleClickClr(){
            this.resumeNumber2S = ''
            this.resumeNumber2UrlS = ''
        },

        handleCotShowClers5(){
            this.handleCotShow = false
        },
        handleClrShowClers5(){
            this.handleClrShowtextarea = ''
            this.handleClrShow = false
        },
        handleCot(itme){
            let { interviewId, interviewData, interviewOpinion, interviewResult} = itme
            this.interviewId = interviewId
            this.CotRadioCntShowtextarea = interviewOpinion
            this.CotRadio = interviewResult === '未通过' ? 1 : interviewResult === '通过' ? 2 : 0


            if(interviewData){
               let JsoninterviewData = JSON.parse(interviewData)
               if(JsoninterviewData.length > 0){
                  this.resumeNumber2S = JsoninterviewData.length > 0 ? JsoninterviewData[0].name : ''
                  this.resumeNumber2UrlS = JsoninterviewData.length > 0 ? JsoninterviewData[0].url : ''
               }
            }


            this.handleCotShow = true
        },
        handleClr(interviewId){
            this.interviewId = interviewId
            this.handleClrShow = true
        },

        handleDownload1(){
            let ele = document.createElement('a')
            ele.setAttribute('href', this.showImgDingurlsss)
            document.body.appendChild(ele)
            ele.click()
        },

        showshowInfoViewInfoClers5(){
            this.urls = ''
            this.showInfoss = false
        },

        showImgDingClers5(){
            this.showImgDing = false
            this.showImgDingurlsss = ''
        },

        handleClick(urlObj){
            let name = urlObj[0].name
            let url = urlObj[0].url



            if(url){

                if(this.getFileName(name) === ".pdf"){
                    this.urls = url
                    this.showInfo = true
                }

                if(this.getFileName(name) === ".jpg" || this.getFileName(name) === ".png"){
                    this.urls = url
                    this.showInfoss = true
                }

                if(this.getFileName(name) === ".docx" || this.getFileName(name) === ".doc"){
                    this.docxContent = url
                    this.showInfos = true
                }

                if(this.getFileName(name) === ".MP3" || this.getFileName(name) === ".mp3"){
                    this.docxContentMp3 = url
                    this.showInfosMp3 = true
                }

                if(this.getFileName(name) === ".MP4" || this.getFileName(name) === ".mp4"){
                    this.docxContentMp4 = url
                    this.showInfosMp4 = true
                }

            }
        },

        startTimeSelect(val, row) {
            if (val == "start") {
                this.InterviewStartTime11 = row;
            } else {
                const date1 = new Date('2024-01-01T' + this.InterviewStartTime11);
                const date2 = new Date('2024-01-01T' + row);
                if (date1 < date2) {
                    this.InterviewEndTime11 = row;
                }else{
                    this.InterviewEndTime11 = ''
                    this.$message({type: 'warning', message: '开始时间不能小于结束时间' })
                }
            }
        },

        startTimeSelect2(val, row) {
            if (val == "start") {
                this.InterviewStartTime22 = row;
            } else {
                const date1 = new Date('2024-01-01T' + this.InterviewStartTime22);
                const date2 = new Date('2024-01-01T' + row);
                if (date1 < date2) {
                    this.InterviewEndTime22 = row;
                }else{
                    this.InterviewEndTime22 = ''
                    this.$message({type: 'warning', message: '开始时间不能小于结束时间' })
                }
            }
        },

        startTimeSelect3(val, row) {
            if (val == "start") {
                this.InterviewStartTime33 = row;
            } else {
                const date1 = new Date('2024-01-01T' + this.InterviewStartTime33);
                const date2 = new Date('2024-01-01T' + row);
                if (date1 < date2) {
                    this.InterviewEndTime33 = row;
                }else{
                    this.InterviewEndTime33 = ''
                    this.$message({type: 'warning', message: '开始时间不能小于结束时间' })
                }
            }
        },

        showshowInfoViewInfoCler(){
            this.showInfo = false
        },

        handleEventChildren(event){
            this.handleAllSearchBtns()
            this.ShowCurrentComponentDialog = event
        },


        handleTreeCheck(e){
            this.resumeNumber3 = e.deptName
            this.resumeNumber3Id = e.deptId
            this.$refs.treeSelect1.visible = false
        },

        handleTreeCheck1(e){
            this.input3 = e.deptName
            this.input3Id = e.deptId
            this.$refs.treeSelect.visible = false
        },

        handleShowCurrentComponentDialogClose(){
            this.currentComponent = ''
            this.ShowCurrentComponentDialog = false
        },

        handleClickImg(e){
            if(e.url){
               let ele = document.createElement('a')
               ele.setAttribute('href', e.url)
               document.body.appendChild(ele)
               ele.click()
            }else{}
        },

        showInterViewInfoCler(){
            this.showInterViewInfo = false
        },

        handdleAllClerIterView(){
            this.InterviewInput1 =  ''
            this.InterviewInput2 =  ''
            this.InterviewInput3 =  ''
            this.InterviewTime1 =  ''
            this.InterviewTime2 =  ''
            this.InterviewTime3 =  ''
            this.InterviewTime11 = [new Date(2016, 9, 10, 10, 0), new Date(2016, 9, 10, 19, 0)]
            this.InterviewTime22 = [new Date(2016, 9, 10, 10, 0), new Date(2016, 9, 10, 19, 0)]
            this.InterviewTime33 = [new Date(2016, 9, 10, 10, 0), new Date(2016, 9, 10, 19, 0)]
            this.InterviewType1 = ''
            this.InterviewType2 = ''
            this.InterviewType3 = ''

            this.InterviewStartTime11 = ''
            this.InterviewEndTime11 = ''
            this.InterviewStartTime22 = ''
            this.InterviewEndTime22 = ''
            this.InterviewStartTime33 = ''
            this.InterviewEndTime33 = ''


            this.isDisabled1 = 0
            this.isDisabled2 = 0
            this.isDisabled3 = 0

            this.interviewId1 = ''
            this.interviewId2 = ''
            this.interviewId3 = ''

        },

        handleArrangeSub(){
            this.handleGetApiAddInterview()
        },


        handleProgramme(dataList){
            dataList.map((itme)=>{
                if(itme.interviewNum === 1){
                    this.interviewId1 = itme.interviewId
                    this.InterviewInput1 = itme.interviewerId
                    this.InterviewType1 = itme.interviewType
                    this.InterviewTime1 = itme.interviewDate
                    this.InterviewStartTime11 = itme.interviewStartTime
                    this.InterviewEndTime11 = itme.interviewEndTime
                    this.isDisabled1 = itme.interviewResult
                }
                if(itme.interviewNum === 2){
                    this.interviewId2 = itme.interviewId
                    this.InterviewInput2 = itme.interviewerId
                    this.InterviewType2 = itme.interviewType
                    this.InterviewTime2 = itme.interviewDate
                    this.InterviewStartTime22 = itme.interviewStartTime
                    this.InterviewEndTime22 = itme.interviewEndTime
                    this.isDisabled2 = itme.interviewResult
                }
                if(itme.interviewNum === 3){
                    this.interviewId3 = itme.interviewId
                    this.InterviewInput3 = itme.interviewerId
                    this.InterviewType3 = itme.interviewType
                    this.InterviewTime3 = itme.interviewDate
                    this.InterviewStartTime33 = itme.interviewStartTime
                    this.InterviewEndTime33 = itme.interviewEndTime
                    this.isDisabled3 = itme.interviewResult
                }
            })
        },


        handleGetApiFindInterViewList(){
            axios.get(`${apiBaseUrl}/interview/findInterViewList/${this.resumesId ? this.resumesId : '' }`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                if(res.data.code === 200){
                   let data = res.data.data
                    if(data.length > 0){
                        this.handleProgramme(data)
                    }
                }else{
                   this.$message({type: 'error', message: 'myysql Query failed code error' })
                }
            })
        },


        handleTimeFprmatSet(timeString){




            const date = new Date(`2016-10-10T00:${timeString}Z`);
            const timeZoneOffset = date.getTimezoneOffset();
            const [hours, minutes] = timeString.split(':').map(Number);
            const timestamp = date.getTime() + (hours - 12) * 3600000 + minutes * 60000;
            const newDate = new Date(timestamp);
            const isoString = newDate.toISOString();



            return isoString
        },

        handleTimeFormat(isoString){
            const date = new Date(isoString);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
            return formattedTime
        },

        handleGetApiAddInterview(){

            let list = []


            if(this.InterviewTime1 && this.InterviewInput1){
                list.push(
                    {
                        resumeId: this.resumesId,
                        interviewDate: this.InterviewTime1,
                        interviewStartTime: this.InterviewStartTime11,
                        interviewEndTime: this.InterviewEndTime11,
                        interviewNum: 1,
                        interviewType: this.InterviewType1,
                        interviewerId: this.InterviewInput1,
                        interviewId: this.interviewId1,
                    }
                )
            }


            if(this.InterviewTime2 && this.InterviewInput2){
                list.push(
                    {
                        resumeId: this.resumesId,
                        interviewDate: this.InterviewTime2,
                        interviewStartTime: this.InterviewStartTime22,
                        interviewEndTime: this.InterviewEndTime22,
                        interviewNum: 2,
                        interviewType: this.InterviewType2,
                        interviewerId: this.InterviewInput2,
                        interviewId: this.interviewId2,
                    },
                )
            }


            if(this.InterviewTime3 && this.InterviewInput3){
                list.push(
                    {
                        resumeId: this.resumesId,
                        interviewDate: this.InterviewTime3,
                        interviewStartTime: this.InterviewStartTime33,
                        interviewEndTime: this.InterviewEndTime33,
                        interviewNum: 3,
                        interviewType: this.InterviewType3,
                        interviewerId: this.InterviewInput3,
                        interviewId: this.interviewId3,
                    }
                )
            }



            axios.post(`${apiBaseUrl}/interview/addInterview`,list,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{


               if(res.data.code == 200){
                  this.ShowInitiateAnIterviewDialog = false
                  list = []
                  this.handdleAllClerIterView()
                  this.$message({type: 'success', message: '提交成功'})
               }else{
                  this.$message({type: 'error', message: res.data.message })
               }
            })
        },

        handleShowInitiateAnIterviewDialogClose(){
            this.ShowInitiateAnIterviewDialog = false
            this.handdleAllClerIterView()
        },

        handleEventClick(clickInfo) {
            this.clickInfoObj  = clickInfo.event._def.extendedProps

            this.showInterViewInfo = true
        },


        handleEvents(events) {
            let index = events.length;
            let eventStop = events[index - 1]
            this.currentEvents = events
        },


        nextClick() {
            let calendarApi = this.$refs["fullCalendar"].getApi()
            calendarApi.next()
            let startTime = this.handdleTimeS(calendarApi.view.activeStart)
            let endTime = this.handdleTimeS(calendarApi.view.activeEnd)

            this.handlefind_trip({ teacherId: this.teacherId, startTime, endTime })

        },


        prevClick() {

            let calendarApi = this.$refs["fullCalendar"].getApi()
            calendarApi.prev()
            let startTime = this.handdleTimeS(calendarApi.view.activeStart)
            let endTime = this.handdleTimeS(calendarApi.view.activeEnd)

            this.handlefind_trip({ teacherId: this.teacherId, startTime, endTime })

        },




        getListAssembly(response) {
            let b = []

            for (let i = 0; i < response.data.data.length; i++) {
                var aa = {
                        classEnding: response.data.data[i].classEnding,
                        title: response.data.data[i].courseName,
                        scheduleId: response.data.data[i].scheduleId,
                        isFirst: response.data.data[i].isFirst,
                        start:  response.data.data[i].courseDate +  " " +  response.data.data[i].courseTimeOn,
                        end:  response.data.data[i].courseDate +  " " +  response.data.data[i].courseEndTime,

                        courseDate: response.data.data[i].courseDate,
                        courseEndTime: response.data.data[i].courseEndTime,
                        courseTimeOn: response.data.data[i].courseTimeOn,
                        courseName: response.data.data[i].courseName,
                        deptName: response.data.data[i].deptName,
                        interviewName: response.data.data[i].interviewName,
                        noteUrl: response.data.data[i].noteUrl ? JSON.parse(response.data.data[i].noteUrl) : [],
                        position: response.data.data[i].position,
                        sex: response.data.data[i].sex === 1 ? '男' : '女',
                        teacherName: response.data.data[i].teacherName,
                        type: response.data.data[i].type === 1 ? '排课行程' : '面试行程',

                }
                var currentTime = new Date()
                var specifiedTime = new Date(aa.start)
                if (currentTime > specifiedTime) {
                    aa.color = "darkgray"
                    aa.isShowbgcColor = true
             } else {
                   aa.isShowbgcColor = false;
                }
                b.push(aa);
            }

            this.calendarOptions.events = b
            loadingUtils.endLoading()
        },


        handdleTimeS(date1) {
            let y = date1.getFullYear();
            let m = date1.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            let d = date1.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date1.getHours();
            h = h < 10 ? "0" + h : h;
            let M = date1.getMinutes();
            M = M < 10 ? "0" + M : M;
            let s = date1.getSeconds();
            s = s < 10 ? "0" + s : s;
            return y + "-" + m + "-" + d;
        },


        handleInput(e){
            axios.get(`${apiBaseUrl}/organizational/getOrgTree?deptName=${e}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                if(res.data.data){
                    this.dataTree = res.data.data
                }else{
                    this.dataTree = []
                }
            })
        },


        handlehandleRadioShowSub(){
            if(this.InternalReferrer){
                this.handleRadioShow = false
            }else{
                this.$message({type: 'warning', message: '请填写内推人~'})
            }
        },

        handlehandleRadioShowClose(){
            this.resumeNumber12 = ''
            this.handleRadioShow = false
        },

        handleRadio(type){
            this.handleRadioShow = type === '是' ? true : false
            if(type === '否'){
                this.InternalReferrer = ''
            }
        },

        handleGetApiAll(){
            axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
               this.optionList1 = res.data.data
               this.optionList3 = res.data.data
               this.optionList5 = res.data.data
            })



            axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTrees = res.data.data})
            axios.get(`${apiBaseUrl}/teacher/query/job`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {this.jobs = res.data.data.list})

            getSubject().then(res => {
                this.subjectArr = res.data
                this.optionList4 = res.data
            })

            axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                this.dataTree = res.data.data
                let datas = {  deptId: this.dataTree[0].deptId, pageNo: 1, pageSize: 100000 }
                axios.post(`${apiBaseUrl}/organizational/getOrgStaffs`, datas ,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                    if(res.data.code == 200){
                        if(res.data.data){
                            this.isTeacherList = res.data.data.list
                        }else{
                            this.isTeacherList = []
                        }
                    }else{
                        this.$message({type: 'error', message: res.data.message})
                    }
                })

            })

            this.handleAllSearchBtns()
        },


        handleAddCilckTemplate(type){
            if(type === '邮箱模版'){
                this.showComponents = true
            }
        },

        AddexportBtnss(){
            this.resumeNumber1 =  'Mengzhen_' + generateRandomCode(45),

            console.log(this.resumeNumber1 , 'Mengzhen_D05ed5yxQVIXqWjixSP1ZyxAtisQyLz6wff5eThTb3unH')

            this.types = '添加'
            this.isShowEdit = false
            this.isDisabled = false
            this.ShowAddTemplateDialog = true
        },

        handleClerAllValue(){
            this.resumeNumber1 =  ''
            this.resumeNumber15 =  ''
            this.resumeNumber2 =  ''
            this.resumeNumber3 =  ''
            this.resumeNumber13 =  1
            this.resumeNumber3Id =  ''
            this.resumeNumber4 =  ''
            this.resumeNumber5 =  ''
            this.resumeNumber6 =  ''
            this.resumeNumber7 =  ''
            this.resumeNumber8 =  ''
            this.resumeNumber9 =  ''
            this.resumeNumber10 = ''
            this.resumeNumber11 = ''
            this.resumeNumber12 = ''
            this.InternalReferrer = ''
        },

        handleShowAddTemplateDialogClose(){
            this.handleClerAllValue()
            this.showComponents = false
            this.ShowAddTemplateDialog = false
        },


        handleShowAddTemplateDialogSub(){
            if(this.resumeNumber2){
               if(this.resumeNumber4 && this.resumeNumber5 && this.resumeNumber6 && this.resumeNumber7 && this.resumeNumber8 && this.resumeNumber10 && this.resumeNumber11 && this.resumeNumber15){
                 this.handlePeopleAddNote()
               }else{
                 this.$message({type: 'warning', message: '请填写必填项~'})
               }
            }else{
               this.$message({type: 'warning', message: '请上传简历'})
            }

        },


        handlePeopleAddNote(){
            let jsonObj = { url: this.resumeNumber2Url,   name: this.resumeNumber2 }
            let data = {
                resumesId: this.resumeNumber1,
                regionName: this.resumeNumber13,
                // noteUrl: this.resumeNumber2,
                noteUrl: JSON.stringify(jsonObj),
                deptId: this.resumeNumber3Id,
                name: this.resumeNumber4,
                age: this.resumeNumber5,
                sex: this.resumeNumber6,
                telPhone: this.resumeNumber7,
                email: this.resumeNumber8,
                categoryIds: '[' + this.resumeNumber9 + ']',
                graduationTime: this.resumeNumber10,
                graduationSchool: this.resumeNumber11,
                notePush: this.resumeNumber12 === '是' ? 1 : 2,
                pushPeople: this.InternalReferrer,
                education: this.resumeNumber15,
            }

            let types = this.types === '编辑' ? 'updatePeopleNoteInfoById' : 'addNote'

            axios.post(`${apiBaseUrl}/people/${types}`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
               if(res.data.code == 200){
                    this.handleClerAllValue()
                    this.ShowAddTemplateDialog = false
                    this.showComponents = false
                    this.$message({type: 'success', message: '添加成功'})

                    this.handleAllSearchBtns(false)

               }else{
                  this.$message({type: 'error', message: '添加失败' })
               }
            })
        },



        searchBtns(){
           this.handleAllSearchBtns()
        },


        handleAllSearchBtns(boom = true){
            let data = {
                pageNum: this.pageNum ? this.pageNum : 1,
                pageSize: this.pageSize ? this.pageSize : 10,
                name: this.input1,
                sex: this.input2,
                deptId: this.input3Id,
                categoryIdList: this.input4 ? this.input4 : [],
                createId: this.input5,
                notePush: this.input6,
                resumeStatus: this.input7,
                regionName: this.input9,
                startTime:this.input8[0] || '',
                endTime:this.input8[1] || '',
                regionName:this.input9 ||  localStorage.getItem('cityTepy'),
            }

            axios.post(`${apiBaseUrl}/people/searchNotes`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
               if(res.data.code == 200){
                    let data = res.data.data

                    this.pageNum = data.current
                    this.pageSize = data.size
                    this.total = data.total
                    this.dataList = data.records

                   if(boom){
                     this.$message({type: 'success', message: '查询成功'})
                   }else{

                   }
               }else{
                  this.$message({type: 'error', message: '查询失败' })
               }
            })
        },


        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input3Id = ''
            this.input4 = ''
            this.input5 = ''
            this.input6 = ''
            this.input7 = ''
            this.input9 = ''
            this.input8= []
            this.pageNum  = 1
            this.pageSize = 10
            let data = {
                pageNum: this.pageNum ? this.pageNum : 1,
                pageSize: this.pageSize ? this.pageSize : 10,
                name: this.input1,
                sex: this.input2,
                deptId: this.input3Id,
                categoryIdList: this.input4 ? this.input4 : [],
                createId: this.input5,
                notePush: this.input6,
                resumeStatus: this.input7,
                startTime:this.input8[0] || '',
                endTime:this.input8[1] || '',

                regionName:this.input9,

            }
            axios.post(`${apiBaseUrl}/people/searchNotes`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
               if(res.data.code == 200){
                    let data = res.data.data

                    this.pageNum = data.current
                    this.pageSize = data.size
                    this.total = data.total
                    this.dataList = data.records

                    this.$message({type: 'success', message: '查询成功'})
               }else{
                  this.$message({type: 'error', message: '查询失败' })
               }
            })

        },


        handleGetApiFindNoteInfoById(id){

            this.types = '编辑'

            axios.get(`${apiBaseUrl}/people/searchNotes/${id}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                if(res.data.code === 200){

                   let data = res.data.data

                   this.resumeNumber1 = data.resumesId

                   let jsonPase = JSON.parse(data.noteUrl)
                   this.resumeNumber2 = jsonPase.name
                   this.resumeNumber2Url = jsonPase.url


                   this.resumeNumber3 = data.deptName
                   this.resumeNumber3Id = data.deptId

                   this.resumeNumber13 =  data.regionName ? Number(data.regionName) : ''

                   this.resumeNumber4 = data.name
                   this.resumeNumber5 = data.age
                   this.resumeNumber6 = data.sex
                   this.resumeNumber7 = data.telPhone
                   this.resumeNumber8 = data.email

                   this.resumeNumber9 = JSON.parse(data.categoryIds)
                   this.resumeNumber10 = data.graduationTime
                   this.resumeNumber11 = data.graduationSchool
                   this.resumeNumber12 = data.notePush === 1 ? '是' : '否'
                   this.InternalReferrer = data.pushPeople

                   this.resumeNumber15 = data.education

                }else{
                    this.$message({type: 'error', message: res.data.msg })
                }
            })
        },

        handleSelectChange(){
            this.$nextTick(()=>{
                this.$refs.selectRef.blur()
            })
        },

        handleGetApigetInterviewFlowInfo(id){
            axios.get(`${apiBaseUrl}/people/findFlow/${id}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                if(res.data.code === 200){
                   let data = res.data.data


                   if(data.length > 0){
                      this.timelineList = data

                      this.timelineList.forEach((itme,index)=>{



                        if(itme.interviewData){
                            let arr = JSON.parse(itme.interviewData)
                            if(arr.length > 0){
                                itme.interviewDatas = arr
                            }
                         }

                         if(itme.categoryNames && itme.categoryNames.length > 0){

                            itme.categoryNames = itme.categoryNames.join(',')
                         }

                         if(index === 0){
                            itme.color = '#ed9612'
                         }
                         if(index === 1){
                            itme.color = 'rgb(65, 231, 102)'
                         }
                         if(index === 2){
                            itme.color = '#c427d5'
                         }
                         if(index === 3){
                            itme.color = '#f9660d'
                         }
                         if(index === 4){
                            itme.color = '#e32daa'
                         }
                         if(index === 5){
                            itme.color = '#4f88df'
                         }
                         if(index === 6){
                            itme.color = '#2aebd285'
                         }
                      })



                   }else{
                      this.timelineList = []
                   }
                }else{
                   this.$message({type: 'error', message: res.data.msg })
                }
            }).catch((err)=>{
                this.$message({type: 'error', message: err })
            })


        },

        handleClickView(type,row){

            let { noteUrl, id, processId, resumesId } = row

            if(type === '详情'){

                this.handleGetApiFindNoteInfoById(resumesId)
                this.handleGetApigetInterviewFlowInfo(resumesId)

                this.isShowEdit = true
                this.isDisabled = true
                this.ShowAddTemplateDialog = true
            }

            if(type === '编辑'){

                this.handleGetApiFindNoteInfoById(resumesId)
                this.handleGetApigetInterviewFlowInfo(resumesId)

                this.isShowEdit = true
                this.isDisabled = false
                this.ShowAddTemplateDialog = true
            }

            if(type === '发起面试'){
                axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTree = res.data.data })

                this.resumesId = resumesId

                this.handleGetApiFindInterViewList()

                this.ShowInitiateAnIterviewDialog = true


                this.$nextTick(()=>{
                    const Dom = document.getElementsByClassName("fc-today-button")[0];
                    Dom.addEventListener("click", (e) => {
                        e.preventDefault()
                        this.handlefind_trip({ teacherId: this.teacherId, startTime:this.startTime, endTime:this.endTime })
                    })
                })

            }

            if(type === '可预览'){

                let jsonObj = JSON.parse(noteUrl)

                if(this.getFileName(jsonObj.url) === ".pdf"){
                    this.urls = jsonObj.url
                    this.showInfo = true
                }else if (this.getFileName(jsonObj.url) === ".docx" || this.getFileName(jsonObj.url) === ".doc"){


                    this.docxContent = jsonObj.url
                    this.showInfos = true

                }else if (this.getFileName(jsonObj.url) === ".jpg" || this.getFileName(jsonObj.url) === ".png"){
                    this.showImgDingurlsss = jsonObj.url
                    this.showImgDing = true
                }
                else{
                    this.$message({type: 'warning', message: '请检查是否为有效的简历类型~' })
                }

                // let ele = document.createElement('a')
                // ele.setAttribute('href', jsonObj.url)
                // document.body.appendChild(ele)
                // ele.click()
            }

            if(type === 'offer'){

                this.resumesId = resumesId
                this.currentComponent = 'followUpComponents'  // offer跟进

                // this.currentComponent = 'grantComponents'  // offer发放

                // this.currentComponent = 'employmentComponents'  // offer入职

                this.ShowCurrentComponentDialog = true
            }

        },

        showshowInfoViewInfoClers(){
            this.showInfos = false
        },
        showshowInfoViewInfoClers3(){
            this.docxContentMp3 = ''
            this.showInfosMp3 = false
        },
        showshowInfoViewInfoClers4(){
            this.docxContentMp4 = ''
            this.showInfosMp4 = false
        },

        handleDownload(){
            let ele = document.createElement('a')
            ele.setAttribute('href', this.docxContent)
            document.body.appendChild(ele)
            ele.click()
        },


        handleClickPeview(){
            if(this.getFileName(this.resumeNumber2Url) === ".pdf"){
                this.urls = this.resumeNumber2Url
                this.showInfo = true
            }else if (this.getFileName(this.resumeNumber2Url) === ".docx" || this.getFileName(this.resumeNumber2Url) === ".doc"){
                this.docxContent = this.resumeNumber2Url
                this.showInfos = true
            }else{
                this.$message({type: 'warning', message: '请检查是否为有效的简历类型~' })
            }
        },

        handleCurrentChange(Current){
            this.pageNum = Current
            this.handleAllSearchBtns()

        },

        handleSizeChange(Size){
            this.pageSize = Size
            this.handleAllSearchBtns()
        },



        handleRemove(file, fileList){
            this.fileDataList = fileList
        },

        getFileName(name) {
             return name.substring(name.lastIndexOf("."))
        },

        beforeUpload(file, fileList){
            loadingUtils.startLoading()
            const fileExtensions = this.getFileName(file.name) === ".pdf" ||
                this.getFileName(file.name) === ".bmp" ||
                this.getFileName(file.name) === ".tif" ||
                this.getFileName(file.name) === ".gif" ||
                this.getFileName(file.name) === ".pcx" ||
                this.getFileName(file.name) === ".svg" ||
                this.getFileName(file.name) === ".psd" ||
                this.getFileName(file.name) === ".webp" ||
                this.getFileName(file.name) === ".apng" ||
                this.getFileName(file.name) === ".ai" ||
                this.getFileName(file.name) === ".avif" ||
                this.getFileName(file.name) === ".png" ||
                this.getFileName(file.name) === ".pdf"||
                this.getFileName(file.name) === ".mp4"||
                this.getFileName(file.name) === ".excel"||
                this.getFileName(file.name) === ".doc"||
                this.getFileName(file.name) === ".ppt"||
                this.getFileName(file.name) === ".mp3"||
                this.getFileName(file.name) === ".xls"||
                this.getFileName(file.name) === ".xlsx"||
                this.getFileName(file.name) === ".pptx"||
                this.getFileName(file.name) === ".docx" ||
                this.getFileName(file.name) === ".txt"||
                this.getFileName(file.name) === ".png"||
                this.getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                this.$message({type: 'warning', message: '不合格式，请上传（合适的简历）格式' })
                loadingUtils.endLoading()
            }

            return fileExtensions && max20M
        },
        handleUpload(option){
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            let objName = option.file.name
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()

                let replacedStr = res.name.replace("mz_pc/", "")
                res.name =  replacedStr

                this.fileDataList.push(res)

                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        },

        handleError(){
            loadingUtils.endLoading()
        },

        uploadShowDlongCler(){
            this.fileDataList = []


            this.resumeNumber2S = ''
            this.resumeNumber2UrlS = ''

            if(this.handleCotShow){
                this.resumeNumber2S = ''
                this.resumeNumber2UrlS = ''
            }else{
                this.resumeNumber2 = ''
                this.resumeNumber2Url = ''
            }

            this.uploadShowDlong = false
        },

        uploadShowDlongSub(){

            if(this.handleCotShow){
                this.resumeNumber2S = this.fileDataList[0].name
                this.resumeNumber2UrlS = this.fileDataList[0].url
            }else{
                this.resumeNumber2 = this.fileDataList[0].name
                this.resumeNumber2Url = this.fileDataList[0].url
            }

            this.uploadShowDlong = false
            this.fileDataList = []
        },

        handleDelet(){
            this.resumeNumber2 = ''
            this.resumeNumber2Url = ''
        },

        handleShowUpload(){
            this.uploadShowDlong = true
        },

        handlefind_trip(data){
            loadingUtils.startLoading()

            if(data.teacherId || this.teacherId){
                let datas = { teacherId: data.teacherId ? data.teacherId : this.teacherId, startTime: data.startTime ? data.startTime : this.startTime, endTime: data.endTime ? data.endTime : this.endTime }
                axios.post(`${apiBaseUrl}/people/find_trip`, datas ,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                    if(res.data.code == 200){
                      this.getListAssembly(res)
                      loadingUtils.endLoading()
                    }else{
                      this.$message({type: 'error', message: res.data.message})
                      loadingUtils.endLoading()
                    }
                })
            }else{
                loadingUtils.endLoading()
                this.$message({type: 'warning', message: '请选择面试官' })
            }

            let isShowmyTour = localStorage.getItem('isShowmyTour')
            if(isShowmyTour){

            }else{
                this.$tours['myTour'].start()
                localStorage.setItem('isShowmyTour', true)
            }

        },

        handleClickTree(data){
            let datas = {  deptId: data.deptId, pageNo: 1, pageSize: 100000 }
            axios.post(`${apiBaseUrl}/organizational/getOrgStaffs`, datas ,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                if(res.data.code == 200){
                    if(res.data.data){
                        this.isTeacherList = res.data.data.list
                    }else{
                        this.isTeacherList = []
                    }
                }else{
                    this.$message({type: 'error', message: res.data.message})
                }
            })
        },

        handleClickTreeRealname(row){

            this.teacherId = row.id
            let parmas = { teacherId: this.teacherId, startTime:this.startTime, endTime:this.endTime }
            this.handlefind_trip(parmas)
        },

        handleInitTime(){
            const now = new Date()
            const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
            const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            this.startTime = this.formatConvert(new Date( firstDay.getFullYear(),firstDay.getMonth(), firstDay.getDate()))
            this.endTime = this.formatConvert(new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate()))
        },


        formatConvert(date) {
            let myyear = date.getFullYear();
            let mymonth = date.getMonth() + 1;
            let myweekday = date.getDate();
            if (mymonth < 10) {
                mymonth = "0" + mymonth;
            }
            if (myweekday < 10) {
                myweekday = "0" + myweekday;
            }
            return myyear + "-" + mymonth + "-" + myweekday;
        },

    },



}


</script>

<style lang="less" scoped>

    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }

    .box{
        position: fixed;
        background: #f3f3f3;
        width: 100%;
        z-index: 1111;
        top: 0;
        left: 0;
        height: 100vh;
        margin: 0;
    }

    /deep/ .el-progress__text{
        opacity: 0;
    }


    /deep/ .el-timeline-item__timestamp {
        text-align: start;
    }


    .demo-app-calendar .fc-past-event {
       background-color: gray;
    }

    .demo-app-main {
        flex-grow: 1;
        padding: 3em 3em 0 1.5em;
    }

    .demo-app-calendar .fc-past-event {
       background-color: gray;
    }

	.no-click {
        pointer-events: none;
    }


    // /* 自定义滚动条整体样式 */
    // ::-webkit-scrollbar {
    //     width: 12px; /* 水平滚动条的高度、垂直滚动条的宽度 */
    //     background-color: #f9f9f9;
    // }

    // /* 自定义滚动条轨道样式 */
    // ::-webkit-scrollbar-track {
    //     background: #e1e1e1; /* 可以是透明的 */
    //     border-radius: 10px;
    // }

    // /* 自定义滚动条滑块样式 */
    // ::-webkit-scrollbar-thumb {
    //     background-color: #c1c1c1;
    //     border-radius: 10px;
    //     border: 2px solid #ffffff; /* 可选的，为滑块添加边框 */
    // }

    // /* 滚动条在悬停或者点击时的样式 */
    // ::-webkit-scrollbar-thumb:hover {
    //    background: #a8a8a8;
    // }



    /deep/ .docx-wrapper{
        background:#fff;
    }

    /deep/ .docx-wrapper > section.docx{
        box-shadow: 0 0 #fff;
        width: 100% !important;
        padding: 0px !important;
    }

</style>



// WEBPACK FOOTER //
// src/InterviewManagement/InterviewManagement.vue